import { api_get, PROYECT } from "services/api"

export const getContractPeriods = async(idContract, setSnackbar) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/pre_pay_roll/status/by_contract?id=${idContract}`
  return await api_get(url)
    .then(periods => periods)
    .catch(err => {
      setSnackbar(err)
      return []
    })
}